import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button.js';
import { p as props } from './componentEl-33ff2aeb.js';
import Group from './Group.js';
import Typography from './Typography.js';
import PageWrapper from './PageWrapper.js';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import './Icon.js';
import './spacing-d13ff368.js';

/**
 * Individual item for SkipToContent component
 */

function SkipToContentItem(_ref) {
  let {
    componentEl
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl"]);

  return /*#__PURE__*/React.createElement(Button, _extends({
    secondary: true,
    fullWidth: true,
    componentEl: componentEl,
    className: "st_skip--focusable"
  }, otherProps));
}

SkipToContentItem.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props
};
SkipToContentItem.defaultProps = {
  componentEl: 'a'
};
SkipToContentItem.displayName = 'SkipToContent.Item';

/**
Sub-navigation component for web apps with multiple sections
*/

function SkipToContent(_ref) {
  let {
    componentEl: Component,
    alwaysVisible,
    className,
    children,
    label
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "alwaysVisible", "className", "children", "label"]);

  let cssClasses = ['st_skip'];
  if (alwaysVisible) cssClasses.push('st_skip--fixed');
  cssClasses = addClassNames(className, cssClasses);
  return /*#__PURE__*/React.createElement("div", {
    className: "st_skip_wrap",
    "aria-label": label
  }, /*#__PURE__*/React.createElement(PageWrapper, null, /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), /*#__PURE__*/React.createElement(Typography, {
    variant: "label1"
  }, label), /*#__PURE__*/React.createElement(Group, {
    gap: "md",
    className: "st_skip--links",
    direction: "column",
    align: "stretch"
  }, children))));
}

SkipToContent.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,

  /** extra CSS classes, if any */
  className: classNameProps,

  /** instances of `<Button tertiary />` */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,

  /** label for the menu */
  label: PropTypes.string,

  /** force the menu to always be visible, used mostly for testing */
  alwaysVisible: PropTypes.bool
};
SkipToContent.defaultProps = {
  componentEl: 'nav',
  className: null,
  alwaysVisible: false,
  label: 'Skip to Content'
};
SkipToContent.Item = SkipToContentItem;

export default SkipToContent;
